import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import React from 'react';
import { ProductVariant } from 'shopify-buy';

interface ColorDropDownProps {
  variant: number;
  setVariant: (a: number) => void;
  variants: any;
}
export default function ColorDropDown(props: ColorDropDownProps) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);

  const options = props.variants.nodes.map((v: ProductVariant) => {
    return v.title.toUpperCase();
  });

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    props.setVariant(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        variant='outlined'
        fullWidth={true}
        ref={anchorRef}
        aria-label='Button group with a nested menu'
        color='info'
        style={{
          borderRadius: '0px',
          display: 'flex',
          fontFamily: 'OCR A Std',
        }}
        sx={{ mb: 2 }}
      >
        <Button
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label='select merge strategy'
          aria-haspopup='menu'
          onClick={handleToggle}
          style={{
            borderRadius: '0px',
            display: 'flex',
            fontFamily: 'OCR A Std',
            width: '98%',
          }}
        >
          {options[props.variant]} <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        style={{ cursor: 'pointer' }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <List
                  id='split-button-menu'
                  style={{
                    maxHeight: '30rem',
                    overflow: 'auto',
                    maxWidth: '31rem',
                  }}
                >
                  {options.map((option: string, index: number) => (
                    <ListItem
                      key={option}
                      selected={index === props.variant}
                      onClick={(event) => handleMenuItemClick(event, index)}
                      style={{ fontFamily: 'OCR A Std' }}
                    >
                      {option}
                    </ListItem>
                  ))}
                </List>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
